import {useState} from 'react'
import BarcodeScannerComponent from "react-qr-barcode-scanner"
import Spinner from 'react-bootstrap/Spinner'
import Modal from 'react-bootstrap/Modal'

export default function Scanner({onScan,isProcessing,show,handleClose}) {

  const [text, setText] = useState("Scan a barcode")

  return (
    <Modal 
      show={show} 
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <strong>Barcode Scanner</strong>
      </Modal.Header>
      <Modal.Body className="d-flex align-items-center flex-column">
        {!isProcessing&&
          <BarcodeScannerComponent
            videoConstraints={{
              facingMode: "user",
              focusMode:'continuous',
            }}
            width={300}
            height={300}
            onUpdate={(err, result) => {
              if (isProcessing) return
              if (result) {
                setText("Processing")
                onScan(result.text)
              }else {
                setText("Scan a barcode")
              }
            }}//end onUpdate
          />
        }
        {isProcessing&&
          <Spinner animation="border" />
        }
        <p>{text}</p>
      </Modal.Body>
    </Modal>
  )
}